import appNotificationService from '@core/services/utils/appNotificationService';
import {useAppModelStore} from "@core/stores/app/appModelStore";
import AxiosService from '@core/services/app/axiosService';
import authHeader from '@core/services/app/authHeader';

class AppModelService {

  getStoreInstance() {
    if (!this.store) {
      this.store = useAppModelStore()
    }
    return this.store
  }

  /**
   * Load data from server
   */
  async refresh(categoryId) {
    try {
      let response = await AxiosService.post(  "/appModel/findById", {
        id: categoryId}, {headers : authHeader()})
      let models = response.data.models;
      models.forEach((row, index) => {
        row.index = index;
      });
      this.getStoreInstance().load(models);
      return models;
    } catch (error) {
      appNotificationService.pushError(error);
    }
  }

  /**
   * Load data from store after an initial fetch if necessary
   */
  async findById(categoryId) {
    try {
      let response = await AxiosService.post(  "/appModel/findById", {
        id: categoryId}, {headers : authHeader()})
      let models = response.data.models;
      models.forEach((row, index) => {
        row.index = index;
      });
      this.getStoreInstance().load(models);
      return models;
    } catch (error) {
      appNotificationService.pushError(error);
    }
  }

  /**
   * Load data from store after an initial fetch if necessary
   */
  async findByCategory(category) {
    try {
      let response = await AxiosService.post(  "/appModel/findByCategory", {
        category: category}, {headers : authHeader()})
      let models = response.data.models;
      models.forEach((row, index) => {
        row.index = index;
      });
      this.getStoreInstance().load(models);
      return models;
    } catch (error) {
      appNotificationService.pushError(error);
    }
  }

  /**
   * Load models by category without affecting the store
   * Used by property selectors to avoid polluting the main grid data
   */
  async findByCategoryNoStore(category) {
    try {
      let response = await AxiosService.post("/appModel/findByCategory", {
        category: category}, {headers : authHeader()})
      let models = response.data.models || [];
      models.forEach((row, index) => {
        row.index = index;
      });
      // Don't load into store - return directly
      return models;
    } catch (error) {
      appNotificationService.pushError(error);
      return [];
    }
  }

  async add(model) {
    try {
      let response = await AxiosService.post(   "/appModel/create", model,{headers : authHeader()})
      let added = response.data.model
      this.getStoreInstance().add(added)
      appNotificationService.pushInfo(response.data.message)
      return added;
    } catch (error) {
      appNotificationService.pushError(error);
    }
  }

  async update(model) {
    try {
      let response = await AxiosService.post(  "/appModel/update", model,{headers : authHeader()})
      let updated = response.data.model
      this.getStoreInstance().update(updated)
      appNotificationService.pushInfo(response.data.message)
      return updated;
    } catch (error) {
      appNotificationService.pushError(error);
    }
  }

  async delete(model) {
    try {
      let response = await AxiosService.post(   "/appModel/delete", model, {headers : authHeader()})
      let deleted = model;
      this.getStoreInstance().delete(deleted)
      appNotificationService.pushInfo(response.data.message)
      return deleted;
    } catch (error) {
      appNotificationService.pushError(error);
    }
  }

  async syncFromScript(categoryId, scriptCode) {
    try {
      let response = await AxiosService.post("/appModel/syncFromScript", {
        categoryId: categoryId,
        scriptCode: scriptCode
      }, {headers: authHeader()})
      let models = response.data.models || [];
      models.forEach((row, index) => {
        row.index = index;
      });
      this.getStoreInstance().load(models);
      appNotificationService.pushInfo(response.data.message)
      return models;
    } catch (error) {
      appNotificationService.pushError(error);
    }
  }
}

export default new AppModelService();
